import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../../index"
import { happyHourEndpoints } from "./hh.api"

const selectHappyHourResult = happyHourEndpoints.endpoints.getHappyHour.select()

export const selectHappyHour = createSelector(
  (state: RootState) =>
    selectHappyHourResult(
      state as unknown as Parameters<typeof selectHappyHourResult>[0]
    ),
  (res) => ({ data: res?.data ?? null, isLoading: res?.isLoading })
)

export default {
  selectHappyHour
}
